import Typography from '@mui/material/Typography'
import { ConfirmDialogWrapper } from '../../components/ConfirmDialogWrapper'
import { useProfileStore } from '../../store/storeProfile'

export const RecurringPaymentStopDialog = ({ open, handleClose }) => {
    const { changeRecurringPayment, recurringPayment } = useProfileStore((state) => state)

    const handleClick = async () => {
        await changeRecurringPayment({
            is_active: false,
            tariff_uuid: recurringPayment.tariff.id,
        })
        handleClose()
    }

    return (
        <>
            <ConfirmDialogWrapper
                colorSubmitButton="secondary"
                variantCloseButton="contained"
                open={open}
                handleSubmit={handleClick}
                handleClose={handleClose}
                title="Точно отключить автопополнение?"
                submitButtonText="Отключить"
                closeButtonText="Не отключать">
                <Typography variant="body2">
                    При нехватке коинов вам нужно будет вручную пополнять баланс
                </Typography>
            </ConfirmDialogWrapper>
        </>
    )
}
